import { Component, Input, SimpleChanges } from '@angular/core';
import { faMapMarker, faEnvelope, faPhone, faClock, faGlobe } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-nursery-card',
  templateUrl: './nursery-card.component.html',
  styleUrls: ['./nursery-card.component.scss']
})
export class NurseryCardComponent {
  @Input() nursery: any;
  @Input() showListingButton: boolean = false;

  faMapMarker = faMapMarker;
  faEnvelope = faEnvelope;
  faPhone = faPhone;
  faClock = faClock;
  faGlobe = faGlobe;

  constructor() {}

  ngOnInit() {
    // console.log(this.nursery);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['nursery']) {
      // console.log(this.nursery);
    }
  }

  openGoogleMaps(latitude: number, longitude: number) {
    const url = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;
    window.open(url, '_blank');
  }

  openWebsite(website: string) {
    window.open(website, '_blank');
  }
}